import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { USER_LOCALSTORAGE_KEY } from '../../../../../shared/const/localstorage';

interface UpdateHomeworkStatusParams {
    status: string;
    userId: number | string | undefined;
    lessonsId: string | undefined;
}

export const updateHomeworkStatus = createAsyncThunk(
    'lesson/updateHomeworkStatus',
    async ({ lessonsId, userId, status }: UpdateHomeworkStatusParams, thunkAPI) => {

        try {
            // Get the authentication token from local storage
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            // Define the request body
            const requestBody = {
                user_id: userId,
                status: status,
            };

            const response = await axios.put(`/api/lessons/${lessonsId}/homework-status`, requestBody, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Return the response data
            return response.data;
        } catch (error) {
            // Reject the thunk with an error message
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


// id урока должно быть в url а id studentId вместе с status
